import React, { useState } from 'react';
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../components/shared/LanguageSwitcher';
import SpinTaskerLogo from '../../components/shared/SpinTaskerLogo';
import LoginCompany from './LoginCompany';
import LoginCompanyNew from './LoginCompanyNew';
import LoginUnified from './LoginUnified';
import LoginUser from './LoginUser';
import LoginWorker from './LoginWorker';
import LoginWorkerNew from './LoginWorkerNew';
import LoginPartner from './LoginPartner';
import RegisterCompany from './RegisterCompany';
import RegisterCompanyNew from './RegisterCompanyNew';
import RegisterUser from './RegisterUser';
import { Menu, X } from 'lucide-react';
import { trackCtaClick } from '../../utils/googleAnalytics';

const AuthPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const role = searchParams.get("role");
    const type = searchParams.get("type");
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

    const goLogin = (location) => {
      trackCtaClick('login', { cta_location: location });
      navigate('/auth?role=company&type=login');
    };

    const goRegister = (location) => {
      trackCtaClick('register', { cta_location: location });
      navigate('/auth?role=company&type=register');
    };

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Navigation Bar */}
      <nav className="bg-gray-900 border-b border-gray-700 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <SpinTaskerLogo
                linkClassName="flex-shrink-0 cursor-pointer hover:opacity-90 transition-opacity"
                headingClassName="text-2xl font-bold text-green-600 flex items-center cursor-pointer hover:text-green-500 transition-colors"
              />
            </div>
            <div className="hidden md:flex items-center space-x-4">
              <LanguageSwitcher />
              <button
                onClick={() => goLogin('auth_nav')}
                className="text-gray-300 hover:text-green-400 px-3 py-2 rounded-md text-sm font-medium transition-colors"
              >
                {t('auth.login')}
              </button>
              <button
                onClick={() => goRegister('auth_nav')}
                className="bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-green-700 transition-colors"
              >
                {t('auth.register')}
              </button>
            </div>
            <button
              type="button"
              className="md:hidden text-gray-300 hover:text-white focus:outline-none"
              onClick={() => setMobileNavOpen(prev => !prev)}
              aria-label="Toggle navigation menu"
            >
              {mobileNavOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>

          {mobileNavOpen && (
            <div className="md:hidden absolute top-full left-0 w-full bg-gray-900 border-b border-gray-700 shadow-lg">
              <div className="px-4 py-4 space-y-3">
                <LanguageSwitcher />
                <button
                  onClick={() => { setMobileNavOpen(false); goLogin('auth_nav_mobile'); }}
                  className="block w-full text-left text-gray-300 hover:text-green-400 px-3 py-2 rounded-md text-sm font-medium transition-colors"
                >
                  {t('auth.login')}
                </button>
                <button
                  onClick={() => { setMobileNavOpen(false); goRegister('auth_nav_mobile'); }}
                  className="block w-full text-left bg-green-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-green-700 transition-colors"
                >
                  {t('auth.register')}
                </button>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Auth Forms */}
      <div className="min-h-[calc(100vh-4rem)]">
        {role === "user" && type === "login" && <LoginUser />}
        {role === "user" && type === "register" && <RegisterUser />}
        {(role === "company" || role === "worker") && type === "login" && <LoginUnified />}
        {role === "company" && type === "register" && <RegisterCompanyNew />}
        {role === "partner" && type === "login" && <LoginPartner />}
      </div>
    </div>
  )
}

export default AuthPage